var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['main-content-article', 'article_' + _vm.article.id_web_content]},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.article.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }